export const STATUS_KEYS = {
  PAYMENT_PROCESSING: 'payment-processing',
  PAYMENT_SUCCESS: 'payment-success',
  PAYMENT_FAILED: 'payment-failed',
  PLUG_IN: 'plug-in',
  UNPLUG: 'unplug',
  CHARGING_COMPLETE: 'charging-complete',
  UNKNOWN: 'unknown',
};